import script from "./PredicateInputView.vue?vue&type=script&setup=true&lang=js"
export * from "./PredicateInputView.vue?vue&type=script&setup=true&lang=js"

import "./PredicateInputView.vue?vue&type=style&index=0&id=505dbac1&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-505dbac1"]])

export default __exports__